import { Amplify } from 'aws-amplify'

const config = {
    environment: import.meta.env.VITE_APP_ENVIRONMENT,
    region: import.meta.env.VITE_APP_REGION,
    identityPoolId: import.meta.env.VITE_APP_IDENTITY_POOL_ID,
    userPoolId: import.meta.env.VITE_APP_USER_POOL_ID,
    clientId: import.meta.env.VITE_APP_USER_POOL_CLIENT_ID,
    bucketName: import.meta.env.VITE_APP_BUCKET_NAME,
    cognitoDomain: import.meta.env.VITE_APP_COGNITO_DOMAIN,
    identityProvider: import.meta.env.VITE_APP_IDENTITY_PROVIDER_NAME,
    redirectUri: import.meta.env.VITE_APP_REDIRECT_URI,
    skipIntroName: import.meta.env.VITE_APP_SKIP_INTRO_NAME,
    workbenchBaseUrl: import.meta.env.VITE_APP_WORKBENCH_BASE_URL,
}

Amplify.configure({
    Auth: {
        Cognito: {
            userPoolId: config.userPoolId,
            userPoolClientId: config.clientId,
            identityPoolId: config.identityPoolId,
            region: config.region,
            allowGuestAccess: false,
            loginWith: {
                username: true,
                email: true,
                oauth: {
                    domain: config.cognitoDomain,
                    scopes: ['email', 'openid', 'profile'],
                    redirectSignIn: [config.redirectUri || `${window.location.origin}/auth`],
                    redirectSignOut: [config.redirectUri || `${window.location.origin}/signout`],
                    responseType: 'code',
                },
            },
        },
    },
    Storage: {
        S3: {
            bucket: config.bucketName,
            region: config.region,
        },
    },
})

export default config
